// @flow

import React from 'react';
import { Card, CardHeader } from 'seedling/components/card';
import { Collapse, ExpandArrow } from 'seedling/components/collapse';
import styled from 'styled-components';

import type { Node } from 'react';

type Props = {
  collapseId: string,
  label: string,
  children: Node,
  className: string,
  expanded: boolean,
};

type State = {
  expanded: boolean,
};

class CollapsibleCard extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      expanded: !!this.props.expanded,
    };
  }

  render() {
    const { label, collapseId, ...rest } = this.props;

    return (
      <Card useLegacyPadding {...rest}>
        <Clickable>
          <CardHeader
            onClick={this.toggleExpanded}
            label={label}
            wrapRightComponent={false}
            rightComponent={
              <CenteredExpandArrow
                aria-controls={collapseId}
                expanded={this.state.expanded}
              />
            }
          />
        </Clickable>
        <Collapse id={collapseId} isOpened={this.state.expanded}>
          {this.props.children}
        </Collapse>
      </Card>
    );
  }

  toggleExpanded = () => {
    this.setState({ expanded: !this.state.expanded });
  };
}

const CenteredExpandArrow = styled(ExpandArrow)`
  position: absolute;
  right: 19px;
  top: 0px;
  height: 100%;
`;

const Clickable = styled.span`
  cursor: pointer;
  user-select: none;
`;

export default CollapsibleCard;
